<template>
    <div>
        <div class="row info_config">
            <div class="p-2 mb-4 alert alert-unex rounded" role="alert2" v-if="!app.conditionsAccepted">
                <p v-html="$t('s1_use_conditions')"></p>

                <button type="button" @click="acceptConditions()" class="unex-button" data-dismiss="alert"
                    aria-label="Close">
                    {{ $t('s1_accept_conditions_button') }}
                </button>
            </div>
            <div v-if="!app.auth.isLogged && !app.udigitalAlertDismissed"
                class="mb-4 alert alert-unex alert-dismissible fade show" role="alert">
                {{ $t('s1_info_config_func_inicio_sesion') }}

                <button @click="app.dismissAlertUDigital()" type="button" class="close" data-dismiss="alert"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
        <div class="row d-flex justify-content-center" v-if="!app.isSpinnerVisible">
            <div v-for="configurator in app.configurators" class="col-12 col-md-6">
                <div class="d-flex box row mb-4 box-hover" @click.prevent="configuratorSelected(configurator)">
                    <div class="col-12 col-md-12 d-flex align-items-center content-media align-self-md-start">
                        <div
                            class="box-xs-horizontal_large box-md-horizontal_large box-media mb-2 box-media-image box-media-media_content_below box-media-link">
                            <img :src="getImageUrl(configurator)" />
                        </div>
                    </div>
                    <div class="col-12 col-md-12 d-flex align-items-center content-content">
                        <div class="box-content w-100">
                            <div class="content">
                                <a class="color-gray fw-bold">
                                    {{ configurator.name }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import { app } from "../../application.js";

export default {
    name: "configuratorsComponentv2",
    data() {
        return {
            app: app,
        };
    },
    created() {
        app.currentConfiguration.stage = 1;
    },
    beforeMount() {
        this.app.loadConfigurators();
    },
    computed: {
        isMobile: function () {
            let a = window.innerWidth < 600;
            return a;
        }
    },
    components: {
        // configuratorComponent
    },

    methods: {
        async configuratorSelected(configurator) {
            console.error(configurator);
            this.app.currentConfiguration.configurator = configurator;

            let result = await this.app.navigateToNextStage();
            console.error(result);
            if (result == false) {
                // TODO: a revisar pel Gerard, no sé si hi ha algun motiu per posar-ho a null,
                // però si ho fem, en cas que l'usuari cliqui al configurador sense haver acceptat les condicions,
                // al acceptar-les, falla en passar a pantalla 2
                // this.app.currentConfiguration.configurator = null;
            } else {
                // Analytics
                this.app.trackParameterSelection("configurator", configurator.id);
            }
        },
        getImageUrl(configurator) {
            return configurator.image_v2;
        },
        async acceptConditions() {
            await this.app.acceptConditions();
        }
    }
};
</script>

<style lang="scss">
.info_config {
    position: relative;
    max-width: 700px;
    margin: auto;
    font-size: 15px;
}

.textLinkMyConfigs {
    color: #585858 !important;
}

.alert a {
    text-decoration: underline !important;
}
.alert-unex {
    background-color: transparent;
    border-color: #DE271F;
    color: #000000;
}
</style>
